import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { RequestREAD } from 'services/Instances'

const DocumentServices = () => {
  const path = 'Ged'

  const SearchDocument = async (
    cdDocumento: number,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SearchDocumentResponse>> => 
    await RequestREAD.get(`${path}/buscarDocumento`, {
      ...options, 
      headers: {
        
        cdDocumento: cdDocumento,
        stArquivo: true,
      },
    });


    const SearchDocumentv3 = async (
      cdDocumento:number,
      options?: AxiosRequestConfig
    ):Promise<AxiosResponse<Blob>> =>
      await RequestREAD.get(`${path}/buscarDocumentoV3`, {
          ...options,
          headers:{
            cdDocumento:cdDocumento
          }
    });

  return { SearchDocument,SearchDocumentv3 }
}

export interface LstIndice {
  cdTipoIndice: number
  dsValor: string
}

export interface VersaoDocumentoInfo {
  cdVersaoDocumento: number
  cdDocumento: number
  cdVersao: number
  dtEfetivacao: Date
  dtVencimento: Date
  dsTitulo: string
  cdTipoDocumento: number
  dsTipoDocumento: string
  dsArquivoOriginal: string
  lstIndices: LstIndice[]
  idStatusDocumento: number
  file: string
}

export interface SearchDocumentResponse {
  nmArquivo: string
  versaoDocumentoInfo: VersaoDocumentoInfo
  filebytes?: string; 
}

export { DocumentServices }
